import { SVGProps, Ref, forwardRef } from 'react';

export const BellOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.53 11.756 1 9.063s5.967-11.318 11.667-7.93c4.527 2.69 1.334 10.17-.17 13.135-.39.767-.668 1.232-.668 1.232l-1.884-1.12c-.636.847-1.514 1.332-2.66 1.025-1.636-.438-1.99-2.004-1.755-3.65m1.335.793c-.006.285.018.538.071.75.107.424.297.643.712.754s.69.017.993-.297q.045-.045.09-.098zm4.425 1.002L2.907 8.568q.135-.218.292-.463c.623-.97 1.5-2.207 2.53-3.332 1.044-1.14 2.166-2.072 3.263-2.544 1.039-.446 1.996-.465 2.96.107.97.577 1.452 1.463 1.6 2.645.154 1.234-.073 2.712-.51 4.215-.432 1.483-1.037 2.885-1.54 3.926z"
            fill="currentColor"
        />
    </svg>
));
BellOutlinedSize16Glyph.displayName = 'BellOutlinedSize16Glyph';
